// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-31d83773]:export {
  primary: #00263A;
  secondary: #000000;
  accent: #f3a712;
}
[data-v-31d83773]:export {
  primary: #00263A;
  secondary: #000000;
  accent: #f3a712;
}
.chip[data-v-31d83773] {
  background-color: #00263A;
  color: #fff;
  border-radius: 20;
}
RadAutoCompleteTextView Token[data-v-31d83773] {
  background-color: #00263A;
  color: #fff;
}
.ns-dark RadAutoCompleteTextView Token[data-v-31d83773] {
  background-color: #00263A;
  color: #fff;
}
.material[data-v-31d83773] {
  border-bottom-width: 1;
  border-color: #222;
  border-radius: 4 4 0 0;
  background: #eeeeee;
  padding-top: 8;
  padding-left: 16;
  padding-right: 16;
}
.material-dark[data-v-31d83773] {
  border-bottom-width: 1;
  border-color: #eeeeee;
  border-radius: 4 4 0 0;
  background: #404040;
  padding-top: 8;
  padding-left: 16;
  padding-right: 16;
}
.placeholder[data-v-31d83773] {
  color: #555;
  font-size: 10sp;
  margin-bottom: 2;
}
.placeholder-dark[data-v-31d83773] {
  color: #eeeeee;
  font-size: 10sp;
  margin-bottom: 2;
}`, "",{"version":3,"sources":["webpack://./assets/scss/variables.scss","webpack://./fAddress.component.vue","webpack://./components/widgets/fAddress/fAddress.component.vue"],"names":[],"mappings":"AAkBA;EACI,gBAnBM;EAoBN,kBAlBQ;EAmBR,eApBK;ACGT;ADcA;EACI,gBAnBM;EAoBN,kBAlBQ;EAmBR,eApBK;ACST;ACLA;EACI,yBFNM;EEON,WAAA;EACA,iBAAA;ADQJ;ACLA;EACI,yBFZM;EEaN,WAAA;ADQJ;ACLA;EACI,yBFjBM;EEkBN,WAAA;ADQJ;ACLA;EACI,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;ADQJ;ACLA;EACI,sBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;ADQJ;ACLA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;ADQJ;ACNA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;ADSJ","sourcesContent":["$primary: #00263A;\n$accent: #f3a712;\n$secondary: #000000;\n$body-bg: #ffffff;\n$body-color: #000000;\n$component-bg: #ffffff;\n$component-color: $primary;\n$card-cap-bg: $primary;\n$card-cap-color: #fff;\n$complementary: $primary;\n$complementary-color: #ffffff;\n$font-size: 14;\n$border-radius-root: 14px;\n$grid-gutter: 12px;\n$body-font-family: 'Roboto', sans-serif;\n$heading-font-family: 'Lato', 'Trebuchet MS', sans-serif;\n$ripple-color: #414141;\n\n:export {\n    primary: $primary;\n    secondary: $secondary;\n    accent: $accent;\n}\n",":export {\n  primary: #00263A;\n  secondary: #000000;\n  accent: #f3a712;\n}\n\n:export {\n  primary: #00263A;\n  secondary: #000000;\n  accent: #f3a712;\n}\n\n.chip {\n  background-color: #00263A;\n  color: #fff;\n  border-radius: 20;\n}\n\nRadAutoCompleteTextView Token {\n  background-color: #00263A;\n  color: #fff;\n}\n\n.ns-dark RadAutoCompleteTextView Token {\n  background-color: #00263A;\n  color: #fff;\n}\n\n.material {\n  border-bottom-width: 1;\n  border-color: #222;\n  border-radius: 4 4 0 0;\n  background: #eeeeee;\n  padding-top: 8;\n  padding-left: 16;\n  padding-right: 16;\n}\n\n.material-dark {\n  border-bottom-width: 1;\n  border-color: #eeeeee;\n  border-radius: 4 4 0 0;\n  background: #404040;\n  padding-top: 8;\n  padding-left: 16;\n  padding-right: 16;\n}\n\n.placeholder {\n  color: #555;\n  font-size: 10sp;\n  margin-bottom: 2;\n}\n\n.placeholder-dark {\n  color: #eeeeee;\n  font-size: 10sp;\n  margin-bottom: 2;\n}","@import '@/assets/scss/variables.scss';\n\n\n\n@import \"../../../assets/scss/variables.scss\";\n.chip {\n    background-color: $primary;\n    color: #fff;\n    border-radius: 20;\n}\n\nRadAutoCompleteTextView Token {\n    background-color: $primary;\n    color: #fff;\n}\n\n.ns-dark RadAutoCompleteTextView Token {\n    background-color: $primary;\n    color: #fff;\n}\n\n.material {\n    border-bottom-width: 1;\n    border-color: #222;\n    border-radius: 4 4 0 0;\n    background: #eeeeee;\n    padding-top: 8;\n    padding-left: 16;\n    padding-right: 16;\n}\n\n.material-dark {\n    border-bottom-width: 1;\n    border-color: #eeeeee;\n    border-radius: 4 4 0 0;\n    background: #404040;\n    padding-top: 8;\n    padding-left: 16;\n    padding-right: 16;\n}\n\n.placeholder {\n    color: #555;\n    font-size: 10sp;\n    margin-bottom: 2;\n}\n.placeholder-dark {\n    color: #eeeeee;\n    font-size: 10sp;\n    margin-bottom: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
